import * as actionTypes from './actionTypes'
import { LOGOUT_USER } from '../user/actionTypes'

const initialState = {
    roleList: { roles: [], total: 0, error: null, loading: false }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_ROLES:
            return { ...state, roleList: { ...state.roleList, total: 0, error: null, loading: true } }

        case actionTypes.FETCH_ROLES_SUCCESS:
            return { ...state, roleList: { roles: action.payload.roles, total: action.payload.total, error: null, loading: false } }

        case actionTypes.FETCH_ROLES_FAILURE:
            return { ...state, roleList: { roles: [], total: 0, error: action.payload.error, loading: false } }

        case actionTypes.RESET_ROLES:
            return { ...state, roleList: initialState.roleList }



        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/role/reducer.js